const PA = 'PersonalAuto';
const HOP_HO = 'HOPHomeowners';
const HO = 'Homeowners';
const PUP = 'PersonalUmbrella';

const HO_DWELLING = 'hopdwelling';
const HO_RENTERS = 'hoprental';
const HO_CONDO = 'hopcondo';
const HO_LANDLORD_HOME = 'hop_landlord_home_ml';
const HO_LANDLORD_CONDO = 'hop_landlord_condo_ml';
const HO_PARTIAL_COV = [HO_DWELLING, HO_RENTERS, HO_CONDO, HO_LANDLORD_HOME, HO_LANDLORD_CONDO];

const PA_MODERN_PRODUCT_TYPE = 'FMPA';
const PA_LEGACY_PRODUCT_TYPE = 'legacy';

export default {
    isPersonalAuto: (productCode) => productCode === PA,
    isHomeOwners: (productCode) => productCode === HOP_HO || productCode === HO,
    isPersonalUmbrella: (productCode) => productCode === PUP,
    isHomeOwnersCoveragePart: (partialCov) => HO_PARTIAL_COV.indexOf(partialCov) !== -1,
    getPersonalAutoCode: () => PA,
    getHomeOwnersCode: () => HOP_HO,
    getPersonalUmbrellaCode: () => PUP,
    getDwellingCode: () => HO_PARTIAL_COV[0],
    getRentalCode: () => HO_PARTIAL_COV[1],
    getCondoCode: () => HO_PARTIAL_COV[2],
    getLandlordHome: () => HO_PARTIAL_COV[3],
    getLandlordCondo: () => HO_PARTIAL_COV[4],
    getHomeOwnersPartialCoverages: () => HO_PARTIAL_COV,
    isHomeOwnersPartialTypeHome: (partialCov) => HO_PARTIAL_COV[0] === partialCov,
    isHomeOwnersPartialTypeRental: (partialCov) => HO_PARTIAL_COV[1] === partialCov,
    isHomeOwnersPartialTypeCondo: (partialCov) => HO_PARTIAL_COV[2] === partialCov,
    isHomeOwnersPartialTypeLandlordHome: (partialCov) => HO_PARTIAL_COV[3] === partialCov,
    isHomeOwnersPartialTypeLandlordCondo: (partialCov) => HO_PARTIAL_COV[4] === partialCov,
    isModernProductPersonalAuto: (productCode, productType) => productCode === PA && productType === PA_MODERN_PRODUCT_TYPE,
    isLegacyPersonalAuto: (productCode, productType) => productCode === PA && (productType === undefined || productType === PA_LEGACY_PRODUCT_TYPE)
};
